import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatMenuPanel } from '@angular/material/menu';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TransactionHistoryElement } from '../../../../interfaces/transaction-history-element.interface';
import { TransactionHistoryRequest } from '../../../../interfaces/transaction-history-request.interface';
import { BackendAccessService } from '../../../../Services/APICalls/backend-access-service';
import { AuthService } from '../../../../Services/Auth/auth.service';
import { UserProfileData } from '../../../../interfaces/user-profile-data';
import { map, Observable, startWith, take } from 'rxjs';
import { CompanySearch } from '../../../../interfaces/company-search.interface';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { BranchSelectionService } from '../../../../Services/branch-selection.service';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { LoadingService } from '../../../../Services/Loading/loading-service.service';

/**
 * @title Table with sorting
 */
@Component({
    selector: 'app-table',
    styleUrls: ['table.component.scss'],
    templateUrl: 'table.component.html',
    standalone: false
})
export class TableComponent implements AfterViewInit, OnInit, OnChanges {
  @ViewChild('menu') menu: MatMenuPanel | any | undefined;
  Export!: object;
  TransferHistoryTable!: any;
  isFirstLoad: boolean = true;
  @Input() currentView!: string;
  totalRows = 0;
  pageSize = 5;
  currentPage = 0;
  isReceiptHistory = false;
  isTransferHistory = true;
  sortColumn = 'date';
  sortDescending = true;
  searchString: string = '';
  showError: boolean = false;
  accountId!: string;
  branchUpdateInProgress: boolean = false;
  accountNumber!: string;
  businessId!: string;
  form!: UntypedFormGroup;
  options: CompanySearch[] = [];
  filteredOptions: Observable<CompanySearch[]> | undefined;
  transactionHistory!: MatTableDataSource<TransactionHistoryElement>;
  selectedBranch!: string | null;
  displayedColumns: string[] = [
    'date',
    'to',
    'productType',
    'quantity',
    'totalActive',
    'purchaseOrder',
    'notes',
  ];
  doc!: any;
  jsPDF!: any;
  loading = false;
  localDateFormat = navigator.language;
  matMenu!: MatMenuPanel<any> | undefined;
  @Output() branchSelected = new EventEmitter<string>();

  applyFilter(filterValue: any) {
    this.searchString = filterValue;
    this.currentPage = 0;
    this.requestTransactionHistoryData(this.selectedBranch ?? '');
  }

  constructor(
    private backend: BackendAccessService,
    public auth: AuthService,
    public formBuilder: UntypedFormBuilder,
    private branchSelectionService: BranchSelectionService,
    private loadingservice: LoadingService
  ) {
    this.transactionHistory =
      new MatTableDataSource<TransactionHistoryElement>();
  }

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  @ViewChild(MatSort)
  sort!: MatSort;

  /* istanbul ignore next */
  async ngOnInit() {
    this.displayedColumns = [
      'date',
      this.currentView == 'transfers' ? 'to' : 'from',
      'productType',
      'quantity',
      'totalActive',
      'purchaseOrder',
      'notes',
    ];

    let roles: string[] = [];
    this.auth
      .getUserProfile$()
      .pipe(take(1))
      .subscribe((results: UserProfileData) => {
        // gets roles from JWT
        roles = results['http://allegion.com/claims/roles'];

        const isFullControl = roles.some((role) => role === 'FullControl');
        const isTechSupport = roles.some((role) => role === 'TechSupport');
        const isViewOnly = roles.some((role) => role === 'ViewOnly');
      });

    this.branchSelectionService.selectedBranch$.subscribe((selectedBranch) => {
      if (selectedBranch) {
        this.selectedBranch = selectedBranch;
        this.requestTransactionHistoryData(selectedBranch);
        if (!this.isFirstLoad) {
          // Check if it's not the first load to prevent automatic calls
          this.branchUpdateInProgress = true;
          this.requestTransactionHistoryData(selectedBranch);
          this.branchUpdateInProgress = false;
        }
      }
    });
    this.isFirstLoad = false; // Ensure this is set to false after initial checks are done
  }

  /* istanbul ignore next */
  ngAfterViewInit() {
    this.transactionHistory.paginator = this.paginator;
    this.transactionHistory.sort = this.sort;
  }
  /* istanbul ignore next */
  ngOnChanges(changes: SimpleChanges) {
    if (
      !changes['currentView'].firstChange &&
      !this.branchUpdateInProgress &&
      !this.isFirstLoad
    ) {
      if (this.currentView === 'transfers') {
        this.displayedColumns[1] = 'to';
        this.currentPage = 0;
      } else {
        this.displayedColumns[1] = 'from';
        this.currentPage = 0;
      }

      this.branchSelectionService.selectedBranch$
        .pipe(take(1))
        .subscribe((selectedBranch) => {
          this.selectedBranch = selectedBranch;
          this.auth
            .getUserProfile$()
            .pipe(take(1))
            .subscribe((results: UserProfileData) => {
              const roles = results['http://allegion.com/claims/roles'];
              const isFullControl = roles.some(
                (role) => role === 'FullControl'
              );
              const isViewOnly = roles.some((role) => role === 'ViewOnly');
              const isTechSupport = roles.some(
                (role) => role === 'TechSupport'
              );

              if (isFullControl || isViewOnly) {
                this.requestTransactionHistoryData(this.selectedBranch ?? '');
              } else if (isTechSupport) {
                this.requestSupportTransactionHistoryData();
              } else {
                console.log('No permissions');
              }
            });
        });
    }
  }

  /* istanbul ignore next */
  sortChanged(sortState: Sort) {
    this.sortColumn = sortState.active;
    this.sortDescending = sortState.direction === 'desc' ? true : false;
    this.requestTransactionHistoryData();
  }
  /* istanbul ignore next */
  pageChanged(event: PageEvent) {
    console.log('hit this');
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.requestTransactionHistoryData(this.selectedBranch ?? '');
  }
  /* istanbul ignore next */
  togglePopup() {
    if (this.showError) {
      this.showError = false;
    } else {
      this.showError = true;
    }
  }
  /* istanbul ignore next */
  requestTransactionHistoryData(brid: string = '') {
    this.loadingservice.show();
    const postData: TransactionHistoryRequest = {
      isrcpt: this.currentView !== 'transfers',
      istrn: this.currentView !== 'receipts',
      // frm: null,
      // to: null,
      srtclm: this.sortColumn,
      srtdsc: this.sortDescending,
      pgn: this.currentPage,
      prpg: this.pageSize,
      srchstr: this.searchString,
      brid: brid === '' ? undefined : brid,
    };
    this.backend.getTransactionHistory(postData).subscribe({
      next: (results) => {
        this.transactionHistory =
          new MatTableDataSource<TransactionHistoryElement>(
            results.creditHistoryTransactions
          );
        this.totalRows = results.totalRecordCount;
        this.loadingservice.hide();
      },
      // on errors
      error: (error) => {
        this.togglePopup(), this.loadingservice.hide();
      },
      // called once on completion

      complete: () => this.loadingservice.hide(),
    });
  }
  /* istanbul ignore next */
  requestSupportTransactionHistoryData() {
    this.loadingservice.show();
    const postData: TransactionHistoryRequest = {
      isrcpt: this.currentView !== 'transfers',
      istrn: this.currentView !== 'receipts',
      // frm: null,
      // to: null,
      srtclm: this.sortColumn,
      srtdsc: this.sortDescending,
      pgn: this.currentPage,
      prpg: this.pageSize,
      srchstr: this.searchString,
      aid: this.form.controls['myControl2'].value.accountNumber,
    };
    this.backend.getTransactionHistory(postData).subscribe({
      next: (results) => {
        this.transactionHistory =
          new MatTableDataSource<TransactionHistoryElement>(
            results.creditHistoryTransactions
          );
        this.totalRows = results.totalRecordCount;
        this.loadingservice.hide();
      },
      // on errors
      error: (error) => {
        this.togglePopup(), this.loadingservice.hide();
      },
      // called once on completion

      complete: () => this.loadingservice.hide(),
    });
  }

  /* istanbul ignore next */
  getMenu() {
    return this.menu;
  }
  /* istanbul ignore next */
  downloadPDF() {
    this.loadingservice.show();

    const postData: TransactionHistoryRequest = {
      isrcpt: this.currentView !== 'transfers',
      istrn: this.currentView !== 'receipts',
      // frm: null,
      // to: null,
      srtclm: this.sortColumn,
      srtdsc: this.sortDescending,
      pgn: 0,
      prpg: this.totalRows,
      srchstr: this.searchString,
    };

    this.backend.getTransactionHistory(postData).subscribe({
      next: (results) => {
        const transactions = results.creditHistoryTransactions;

        const doc = new jsPDF({
          orientation: 'landscape',
          unit: 'mm',
          format: 'a4',
        });

        let posY = 10; // Start a bit lower to accommodate titles and headers

        // Assuming you have the logo's height and the desired font size for the text
        const logoHeight = 20;
        const fontSize = 12; // Font size for the "History Report" text

        // Add a logo
        const logo =
          '../../../../../assets/Icons/alm full logo orange transp back 1.png'; // Ensure this is the correct path or base64 of the image
        doc.addImage(logo, 'PNG', 10, posY, 50, logoHeight);

        // Calculate the vertical middle point of the logo
        const middleLogoY = posY + logoHeight / 2;

        // Set the font size for calculating text height
        doc.setFontSize(fontSize);

        // To center "History Report" text horizontally, calculate the middle of the page
        const pageWidth = doc.internal.pageSize.getWidth();
        const txt = 'History Report';
        const txtWidth = doc.getTextWidth(txt);

        // Calculate the starting X position to center the text
        const x = pageWidth / 2 - txtWidth / 2;

        // Adjust the Y position so the text is vertically centered to the logo
        // Since jsPDF does not provide the text height directly, this adjustment might need manual tweaking
        // Here, we use the same posY for simplicity, adjust it based on your visual preference
        const textY = middleLogoY + fontSize / 2 - 2; // Adjust the -2 based on visual preference for alignment

        doc.text(txt, x, textY);

        // Adjust posY for subsequent content, considering logo height and some padding
        posY += logoHeight + 5;

        // Headers
        const headers = [
          'Date',
          this.currentView === 'transfers' ? 'To' : 'From',
          'Product Type',
          'Quantity',
          'Total Active',
          'Purchase Order',
          'Notes',
        ];
        posY = this.addHeaders(doc, headers, posY);

        // Transactions
        transactions.forEach((transaction) => {
          let posX = 10; // Reset X position for each new line
          const lineHeight = 7; // Increase line height to prevent overlapping

          // Ensure text fits or is truncated to prevent overlap
          const row = [
            this.formatDate(transaction.date),
            this.truncateText(transaction.to || transaction.from, 30), // Assuming to/from fields can be long
            this.truncateText(transaction.productType, 30),
            transaction.quantity.toString(),
            transaction.totalActive.toString(),
            this.truncateText(transaction.purchaseOrder, 20), // Truncate purchase order if too long
            this.truncateText(transaction.notes, 30), // Truncate notes
          ];

          // Adjust posX increment for "Date" column
          doc.text(row[0], posX, posY);
          posX += 25; // Decreased width for the "Date" column

          doc.text(row[1], posX, posY);
          posX += 60; // Decreased width for the "To/From" column

          doc.text(row[2], posX, posY);
          posX += 50; // Decreased width for the "To/From" column

          doc.text(row[3], posX, posY);
          posX += 25;
          doc.text(row[4], posX, posY);
          posX += 25;

          // Adjust posX for subsequent columns
          for (let i = 5; i < row.length; i++) {
            doc.text(row[i], posX, posY);
            posX += 40; // Adjusted for other columns, modify as needed
          }

          posY += lineHeight;

          // Add a new page if posY exceeds page dimensions
          if (posY > 190) {
            doc.addPage();
            posY = 20; // Reset Y position for new page
            posY = this.addHeaders(doc, headers, posY); // Re-add headers on new page
          }
        });

        doc.save('TransactionHistory.pdf');
        this.loadingservice.hide();
      },
      error: (error) => {
        console.error('Error generating PDF', error);
        this.loadingservice.hide();
      },
      complete: () => this.loadingservice.hide(),
    });
  }

  addHeaders(doc: any, headers: any[], posY: number) {
    let posX = 10; // Starting X position for headers
    // The first header is for the "Date" column, which has a reduced width
    doc.text(headers[0], posX, posY);
    posX += 25; // Adjusted posX increment for "Date" column

    doc.text(headers[1], posX, posY);
    posX += 60;
    doc.text(headers[2], posX, posY);
    posX += 50;

    doc.text(headers[3], posX, posY);
    posX += 25;
    doc.text(headers[4], posX, posY);
    posX += 25;

    // Start loop from the second header
    for (let i = 5; i < headers.length; i++) {
      doc.text(headers[i], posX, posY);
      // posX += 30; // Adjust posX for subsequent headers, aligning with content
      posX += 40; // Adjust posX for subsequent headers, aligning with content
    }

    return posY + 7; // Adjust for spacing after headers
  }

  truncateText(text: string | null | undefined, maxLength: number): string {
    if (!text) {
      return ''; // or return "N/A" or any placeholder you see fit
    }

    return text.length > maxLength
      ? text.substr(0, maxLength - 3) + '...'
      : text;
  }

  formatDate(dateString: any) {
    const date = new Date(dateString);
    return date.toLocaleDateString();
  }

  /* istanbul ignore next */
  private _filter(value: string): CompanySearch[] {
    const filterValue = value.toLowerCase();

    return this.options.filter((option: CompanySearch) =>
      option.businessId.toLowerCase().includes(filterValue)
    );
  }
  /* istanbul ignore next */
  displayName(subject: any) {
    if (subject.businessId) {
      return subject.businessId;
    }
  }
  /* istanbul ignore next */
  loadCompanies() {
    this.loading = true;
    this.backend.getCompanies().subscribe({
      next: (results: CompanySearch[]) => {
        this.options = results;
      },
      error: (error) => {
        this.loading = false;
      },
      complete: () => (this.loading = false),
    });
  }
}
